<template>
  <el-col class="displayLayout" id="personnelManagement">
    <template>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="保单号">
          <el-input v-model="formInline.accode" placeholder="请输入您要查询的保单号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSelect">搜索</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template>
      <el-table
        :data="tableData"
        style="width: 100%;"
        v-loading="loading">
        <el-table-column prop="accode"
                         width="210"
                         label="保单号">
        </el-table-column>
        <el-table-column prop="policyHolderName"
                         min-width="150"
                         label="投保企业">
        </el-table-column>
        <el-table-column prop="issueDate"
                         label="投保日期">
        </el-table-column>
        <el-table-column prop="effectiveDate"
                         label="生效日期">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="onSee(scope.row)" size="mini">批改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page.sync="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </el-col>
</template>

<script>
    export default {
        name: "personnelManagement",
        data() {
          return {
            loading: false,
            page: 1,
            total: 0,
            pageSize: 10,
            tableData: [],
            formInline: {
              accode: '',
            }
          }
        },
      watch: {
        '$route' () {
          this.getPolicyList();
        }
      },
      methods: {
        /**
         * 批改
         * @param row
         */
        onSee(row) {
          const {orderToken, endorOrderToken, productId} = row;
          let requestToken = endorOrderToken;
          this.axios.post('/management/orderEndorInfoLog/createOrderEndor', {
            orderToken: orderToken,
            requestToken: requestToken
          }).then((response) => {
            let data = response.data;
            if (data.success){
              if( data.datas.isEjsino === true ){
                this.$router.push({name: 'ejsinoInsureDetails', query: {productId: productId,orderToken: orderToken, isEndorOrder: 'true'}});
              }else{
                let params = {
                  orderEndorToken: data.datas.orderEndorToken,
                  accode: row.accode,
                };

                sessionStorage.setItem('personnelCorrectingParams', JSON.stringify(params));
                this.$router.push({name: 'personnelCorrecting'});
              }
            } else {
              this.$message.error(data.msg);
            }
          });
        },
        handleSizeChange(val) {
          this.page = 1;
          this.pageSize = val;
          this.getPolicyList();
        },
        handlePageChange(val) {
          this.page = val;
          //保存到sessionStorage
          // sessionStorage.setItem('orderPage', this.page)
          this.getPolicyList();
        },
        onSelect() {
          this.page = 1;
          this.getPolicyList();
        },
        getPolicyList() {
          this.loading = true;
          this.axios.post('/management/mobileOrderInfoLog/getInsurancePolicy',null,{params:{
              _pageSize: this.pageSize,
              _current : this.page,
              insuranceIsGroup: this.$$.isValidObj(this.$route.query.insuranceIsGroup) ? this.$route.query.insuranceIsGroup : 4,
              orderStatus: 2,
              accodeGroup: 1,
              isInsuredStatusSeek: 7,
              accode: this.formInline.accode
            }}).then((response) => {
            let data = response.data;
            if (data.success) {
              this.tableData = data.datas;
              this.page = data.pagination.current;
              this.total = data.pagination.total;
              this.loading = false;
            } else {
              this.$message.error(data.msg);
            }

            let height = $('.displayLayout').outerHeight() - ($('.demo-form-inline').outerHeight() + $('.el-table thead').height() + $('.el-pagination').outerHeight());
            $('.el-table__body-wrapper').css('height', height);
          })
        }
      },
      mounted() {
        if (!this.$$.checkLogin()) return false;

        /*let thePage = sessionStorage.getItem('orderPage');
        if(thePage == null){
          thePage = 1;
        }
        this.page = Number(thePage);*/
        this.getPolicyList();
      }
    }
</script>

<style scoped>
  @import "../../../../../static/css/orderManagement.css";
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/preservation/personnelManagement.vue